import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { uploadData, getUrl } from 'aws-amplify/storage';
import { UploadFileResponse } from './public-storage.service';
import {
    PutObjectCommand,
    PutObjectCommandInput,
    S3Client
} from '@aws-sdk/client-s3';

@Injectable({
    providedIn: 'root'
})
export class StorageService {
    private client = new S3Client(environment.configS3);

    async uploadFile(fileName: string, file: File /*, onProgress: any*/) {
        try {
            // Subir archivo directamente si no es una imagen
            return await uploadData({
                key: fileName,
                data: file
                /*options: {
                    accessLevel: 'guest' // defaults to `guest` but can be 'private' | 'protected' | 'guest'
                    // onProgress // Optional progress callback.
                }*/
            }).result;
        } catch (error) {
            console.log('Error : ', error);
            return error;
        }
    }

    async uploadUnauthFile(
        file: File,
        key: string,
        bucketName: string = environment.bucketDocuments
    ): Promise<UploadFileResponse> {
        return new Promise(async (resolve, reject) => {
            try {
                /*const size = 8 * 1024 * 1024 * 1024;
                if (file.size > size) {
                    console.log('Big file');
                } else {*/
                const input: PutObjectCommandInput = {
                    Bucket: bucketName,
                    Key: `public/${key}`,
                    Body: file,
                    ContentType: file.type
                };
                const command = new PutObjectCommand(input);
                const response = await this.client.send(command);
                resolve({
                    ...response,
                    key
                });
                //}
            } catch (err) {
                console.log(err);
                reject(err);
            }
        });
    }

    // Función auxiliar para verificar si es un archivo de imagen
    isImageFile(file: File): boolean {
        return file.type.startsWith('image/');
    }

    async toBase64(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = error => reject(error);
        });
    }

    convertBase64ToBlob(base64Data: string) {
        const contentType = base64Data
            .split(',')[0]
            .replace('data:', '')
            .replace(/;\s*$/, '');
        const sliceSize = 512;
        const byteCharacters = atob(base64Data.split(',')[1]);
        const byteArrays = [];

        for (
            let offset = 0;
            offset < byteCharacters.length;
            offset += sliceSize
        ) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    async getFileUrl(filename: string) {
        const getUrlResult = await getUrl({
            key: filename,
            options: {
                // accessLevel: 'guest' , // can be 'private', 'protected', or 'guest' but defaults to `guest`
                // targetIdentityId?: 'XXXXXXX', // id of another user, if `accessLevel` is `guest`
                // validateObjectExistence: false,  // defaults to false
                // expiresIn?: 20 // validity of the URL, in seconds. defaults to 900 (15 minutes) and maxes at 3600 (1 hour)
                // useAccelerateEndpoint: true // Whether to use accelerate endpoint.
            }
        });
        return getUrlResult.url.toString();
    }

    toJpeg(base64: string): string {
        const mimeType = 'image/jpeg';
        const data = atob(base64.split(',')[1]);
        const buffer = new ArrayBuffer(data.length);
        const uint8Array = new Uint8Array(buffer);
        for (let i = 0; i < data.length; i++) {
            uint8Array[i] = data.charCodeAt(i);
        }
        const blob = new Blob([uint8Array], { type: mimeType });
        const objectURL = URL.createObjectURL(blob);
        return objectURL;
    }
}
